import _ from 'underscore'
import React from 'react'
import { ChevronDown } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import RelatedResourcesPartial from './partial'

class RelatedResources extends React.Component {

  render() {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Badge asChild variant="secondary" className="cursor-pointer">
            <button type="button">
              {(this.props.related_resources.length > 1) ?
                <span>{this.props.related_resources.length} related enquiries <ChevronDown className="inline size-3"/></span>
                :
                <span>{this.props.related_resources.length} related enquiry <ChevronDown className="inline size-3"/></span>
              }
            </button>
          </Badge>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-96">
          {_.map(this.props.related_resources, (related_resource) => {
            return (
              <RelatedResourcesPartial key={related_resource.id} related_resource={related_resource}/>
            )
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    )
  }
}

export default RelatedResources
